module.exports = __webpack_public_path__ + "img/userLogo15.8a3ffa21.jpg";